import {
  Routes,
  Route,
  RoutesProps,
} from "react-router-dom";
import React, { Suspense, useEffect } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";

const Navigation = () => {

  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));
  const ForgotPassword = React.lazy(() => import("../components/Login/ForgotPassword"));
  const Otp = React.lazy(() => import("../components/Login/Otp"));
  const CratePassword = React.lazy(() => import("../components/Login/CratePassword"));

  const Dashboard = React.lazy(() => import("../components/Dashboard/Dashboard"));

  const CMSListing = React.lazy(() => import("../components/ManageCMS/cms"));
  const AddCMS = React.lazy(() => import("../components/ManageCMS/AddEditCMS"));

  const UserListing = React.lazy(() => import("../components/ManageAdminUser/users"));
  const AddUser = React.lazy(() => import("../components/ManageAdminUser/AddEditUser"));

  const ProfileSetting = React.lazy(() => import("../components/Header/profileSetting"));

  const Occasions = React.lazy(() => import("../components/ManageOccasions/HandleOccasions"));

  const FaqListing = React.lazy(() => import("../components/ManageFAQ/FAQListing"));
  const AddEditFaq = React.lazy(() => import("../components/ManageFAQ/AddEditFAQ"));

  const SupportTicket = React.lazy(() => import("../components/ManageSupportTicket/SupportTicketListing"));

  const AddEditPorduct = React.lazy(() => import("../components/ManageProduct/AddEditProduct"));
  const ProductListing = React.lazy(() => import("../components/ManageProduct/ProductListing"));

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route path="/login" element={<Suspense fallback={<></>}> <Login /> </Suspense>} />
          <Route path="/forgot-password" element={<Suspense fallback={<></>}> <ForgotPassword /> </Suspense>} />
          <Route path="/otp" element={<Suspense fallback={<></>}> <Otp /> </Suspense>} />
          <Route path="/crate-password" element={<Suspense fallback={<></>}> <CratePassword /> </Suspense>} />

          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />} >
            <Route path="/dashboard" element={<Suspense fallback={<></>}> <Dashboard /> </Suspense>} />
            <Route path="/occasions" element={<Suspense fallback={<></>}><Occasions /></Suspense>} />
            <Route path="/faq" element={<Suspense fallback={<></>}><FaqListing /></Suspense>} />

            <Route path="/add-faq" element={<Suspense fallback={<></>}><AddEditFaq /></Suspense>} />
            <Route path="/edit-faq/:id" element={<Suspense fallback={<></>}><AddEditFaq /></Suspense>} />

            <Route path="/support-ticket" element={<Suspense fallback={<></>}><SupportTicket /></Suspense>} />

            <Route path="/cms" element={<Suspense fallback={<></>}> <CMSListing /> </Suspense>} />
            <Route path="/add-cms" element={<Suspense fallback={<></>}> <AddCMS /> </Suspense>} />
            <Route path="/edit-cms/:id" element={<Suspense fallback={<></>}> <AddCMS /> </Suspense>} />

            <Route path="/admin-user" element={<Suspense fallback={<></>}> <UserListing /> </Suspense>} />
            <Route path="/add-user" element={<Suspense fallback={<></>}> <AddUser /> </Suspense>} />
            <Route path="/edit-user/:id" element={<Suspense fallback={<></>}> <AddUser /> </Suspense>} />

            <Route path="/profile-setting" element={<Suspense fallback={<></>}><ProfileSetting /></Suspense>} />

            <Route path="/product" element={<Suspense fallback={<></>}><ProductListing /></Suspense>} />
            <Route path="/add-Product" element={<Suspense fallback={<></>}><AddEditPorduct /></Suspense>} />
            <Route path="/edit-product/:id" element={<Suspense fallback={<></>}><AddEditPorduct /></Suspense>} />
          </Route>
        </Routes >
      </div >
    </>
  );
};

export default Navigation;
